<div class="flex items-stretch gap-2">
  <ng-container *ngFor="let stage of stages; let i = index; let last = last">
    <!-- Stage card -->
    <div
      class="flex items-center gap-3 flex-1 px-4 py-4 rounded-xl border transition-all duration-200"
      [ngClass]="{
        'bg-white border-[var(--primary-300)] shadow-md z-10 relative':
          isCurrentStage(stage),
        'bg-[#f3f6fb] border-transparent shadow-none': !isCurrentStage(stage),
      }"
    >
      <!-- Circle indicator -->
      <div
        class="w-8 h-8 rounded-full flex-shrink-0 flex items-center justify-center transition-all duration-200"
        [ngClass]="{
          'bg-green-500 shadow-sm': isCompleted(stage),
          'border-2 border-[var(--primary-500)] bg-white': !isCompleted(stage),
        }"
      >
        <i
          *ngIf="isCompleted(stage)"
          class="pi pi-check text-white text-xs"
        ></i>
      </div>

      <!-- Content -->
      <div class="flex flex-col min-w-0 flex-1">
        <!-- Label + badge -->
        <div class="flex items-center gap-2 mb-1">
          <span
            class="text-sm font-bold uppercase tracking-wider text-[#17325c]"
          >
            {{ getDisplayLabel(stage) }}
          </span>
          <span
            *ngIf="isCurrentStage(stage)"
            class="font-bold uppercase tracking-wider px-1.5 py-0.5 rounded bg-blue-100 text-blue-700 border border-blue-200 text-xs leading-none"
          >
            {{ stage.badge }}
          </span>
        </div>

        <!-- Date -->
        <div class="flex items-center gap-1.5">
          <span class="text-xs font-semibold truncate text-[#6b7a99]">
            <ng-container *ngIf="getDisplayDate(stage); else noDate">
              {{
                getDisplayDate(stage) | date: "MMM d, yyyy" : undefined : "en"
              }}
            </ng-container>
            <ng-template #noDate
              ><span class="text-[#b0bdd2]">—</span></ng-template
            >
          </span>
        </div>
      </div>
    </div>

    <!-- Connector -->
    <div
      *ngIf="!last"
      class="flex-shrink-0 self-center w-4 h-[2px] bg-[#d7dfef] rounded-full"
    ></div>
  </ng-container>
</div>
